import React, { useState } from 'react';
import './MaintenanceMode.css';
import { useStores } from '../../hooks/use-stores';
import { showConfirmModal } from '../../modules/modals/confirmService';

const MaintenanceMode = () => {
  const ACTIVE_CLASS = 'active';
  const [ active, setActive ] = useState(false);
  const { batchStore } = useStores();

  const toggleMaintenanceMode = () => {
    if (batchStore.running.length) {
      batchStore.showWarning('Can\'t switch Maintenance Mode during the load!');
      return;
    }

    const message = !active
      ? (
        <>
          You are entering Maintenance Mode.
          All bins will maintain and material inventory will be registered only if option <strong>Reduce Maintenance Mode Inventory</strong> is enabled.<br/>
          Are you sure you want to continue?
        </>
      )
      : 'Switch the Maintenance Mode off?';

    showConfirmModal({
      title: 'Maintenance Mode',
      message,
      okLabel: 'Yes',
      cancelLabel: 'No',
      enableEscape: false,
    }).then(() => {
      batchStore.maintenanceMode = !active;
      setActive(!active);
    }).catch(() => {});
  };

  return (
    !batchStore.running.length
      ? (
        <span title={active ? 'Maintenance Mode ON' : 'Maintenance Mode OFF'}
          className={`btn-wrapper maintenance-wrapper ${active ? ACTIVE_CLASS : ''}`}>
          <button className="btn btn-default" data-e2e-id="btn-maintenance-mode"
            onClick={toggleMaintenanceMode}>
            <i className={'fa fa-gear'}/>
          </button>
          {active && 'Maintenance Mode ON'}
        </span>
      )
      : ''
  );
};

export default MaintenanceMode;
